"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sidebar_1 = require("../../../components/web-view/sidebar");
const nav_bar_1 = require("../../../components/web-view/nav-bar");
const react_1 = require("react");
const menuItems_1 = require("./constants/menuItems");
const avatarMenuItems_1 = require("./constants/avatarMenuItems");
const AuthContext_1 = require("../../../hooks/auth/context/AuthContext");
const flags_1 = require("../../../common/feature-flags/flags");
const NavigationComponent = ({ sidebarVisible, toggleSidebar, }) => {
    const { isLoggedIn, userInfo } = (0, AuthContext_1.useAuth)();
    const advertisingEnabled = (0, flags_1.useFeatureFlag)('advertisingEnabledVending');
    const items = (0, react_1.useMemo)(() => advertisingEnabled
        ? menuItems_1.menuItems
        : menuItems_1.menuItems.filter((item) => item.id !== 'advertising'), [advertisingEnabled]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(sidebar_1.SideBarComponent, { visible: sidebarVisible, onHide: toggleSidebar, items: items }), (0, jsx_runtime_1.jsx)(nav_bar_1.NavBarComponent, { isSidebarVisible: sidebarVisible, toggleSidebar: toggleSidebar, subMenuItems: avatarMenuItems_1.avatarMenuItems, userName: isLoggedIn && userInfo && userInfo.username ? userInfo.username : '' })] }));
};
exports.NavigationComponent = NavigationComponent;
